import FlatEquationSolver from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/FlatEquationSolver';
import {
  STOICHIOMETRY_CALCULATION_EQUATIONS,
  StoichiometryVariable,
} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryEquations';

const StoichiometrySolver = new FlatEquationSolver<StoichiometryVariable>(
  STOICHIOMETRY_CALCULATION_EQUATIONS
);

export type StoichiometryCalculationVariableValues = Partial<Record<StoichiometryVariable, number>>;

export default StoichiometrySolver;
